<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "ONT MacAddress Table" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the MAC address table of ont." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'MAC Address Table'" style="height: 100%">
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadOntMacTable()"
                  class="btn"
                  :class="{}"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
            <span style="margin-left: 25px; font-weight: bold"
              >Total entries: {{ total }}</span
            >
            <label style="float: right; display: flex">
              <span class="input-group-addon tablesearch-box">
                <i class="fa fa-search"></i>
              </span>
              <select
                class="form-control"
                @change="searchInfo = ''"
                v-model="searchType"
              >
                <option label="none" value=""></option>
                <option label="pon" value="pon"></option>
                <option label="ont" value="ont"></option>
                <option label="mac" value="mac"></option>
              </select>
              <input
                type="search"
                v-model="searchInfo"
                class="form-control"
                :placeholder="keywords"
                style="border-radius: 0px"
                :disabled="searchType == ''"
              />
            </label>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in ontMacTableList.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 350px">
              <tr v-for="row in ontMacTableListFilter" :key="row.ontid">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  components: {
    BlockCntr,
  },
  data() {
    return {
      ontMacTableList: "",
      searchType: "",
      searchInfo: "",
      total: "",
      keywords: "",
    }
  },
  created() {
    this.loadOntMacTable()
  },
  methods: {
    loadOntMacTable() {
      get("ontMacTable")
        .then((res) => (this.ontMacTableList = res.data))
        .catch((err) => {
          this.ontMacTableList = en.ontMacTable
        })
    },
  },
  watch: {
    searchType: function (newValue, oldValue) {
      if (newValue == "pon") {
        this.keywords = "slot/pon"
      } else if (newValue == "ont") {
        this.keywords = "slot/pon/ont"
      } else if (newValue == "mac") {
        this.keywords = "H:H:H:H:H:H"
      } else {
        this.keywords = ""
      }
    },
  },
  computed: {
    ontMacTableListFilter() {
      var macList = []
      this.total = 0
      if (this.ontMacTableList.data !== undefined)
        this.ontMacTableList.data.forEach((element) => {
          if (
            this.searchInfo == "" ||
            (this.searchType == "pon" &&
              element["ont"].split("/")[0] == this.searchInfo.split("/")[0] &&
              element["ont"].split("/")[1] == this.searchInfo.split("/")[1]) ||
            (this.searchType == "ont" && this.searchInfo == element["ont"]) ||
            (this.searchType == "mac" &&
              element["mac"].indexOf(this.searchInfo) !== -1)
          ) {
            macList.push(element)
            this.total += 1
          }
        })
      return macList
    },
  },
}
</script>